import {
  CLEAN_PLUGROUP,
  SET_PLUGROUP,
  SET_PLUGROUP_LIST,
  SYNC_FAILED,
  SYNC_FINISHED,
  SYNC_INITIATED,
  PLUGROUP_CREATED,
  PLUGROUP_UPDATED,
  UPDATE_INITIATED,
  CREATE_INITIATED,
  PLUGROUP_DELETED,
  DELETE_INITIATED,
  PLU_GROUP_SYNC,
} from './actionTypes';
import {
  IFailedSyncAction,
  ISetPLUGroupAction,
  ISetPLUGroupsAction,
  IPLUGroupsAction,
  IPLUGroupsState,
  IPLUGroup,
  IDeletePLUGroupAction,
} from './types';

const initialSync = {
  syncing: false,
  updateInitiated: false,
  createInitiated: false,
  deleteInitiated: false,
  pluGroupSyncing: false,
};

const resetActionsSync = {
  error: null,
  pluGroupUpdated: false,
  pluGroupCreated: false,
  pluGroupDeleted: false,
};

export const initialState = {
  loaded: false,
  pluGroups: [],
  pluGroup: null,
  ...initialSync,
  ...resetActionsSync,
};

export const reducer = (
  state: IPLUGroupsState = initialState,
  action: IPLUGroupsAction
): IPLUGroupsState => {
  switch (action.type) {
    case SYNC_INITIATED:
      return { ...state, ...resetActionsSync, syncing: true };
    case SYNC_FINISHED:
      return { ...state, ...initialSync };
    case SET_PLUGROUP_LIST:
      return {
        ...state,
        pluGroups: (action as ISetPLUGroupsAction).payload,
        loaded: true,
      };
    case SET_PLUGROUP:
      return {
        ...state,
        pluGroup: (action as ISetPLUGroupAction).payload,
      };
    case PLUGROUP_UPDATED:
      return {
        ...state,
        pluGroupUpdated: true,
      };
    case UPDATE_INITIATED:
      return {
        ...state,
        ...resetActionsSync,
        updateInitiated: true,
      };
    case PLUGROUP_CREATED:
      return {
        ...state,
        pluGroupCreated: true,
      };
    case CREATE_INITIATED:
      return {
        ...state,
        ...resetActionsSync,
        createInitiated: true,
      };
    case PLUGROUP_DELETED:
      return {
        ...state,
        pluGroups: state.pluGroups.filter(
          (pluGroup: IPLUGroup) => pluGroup.pluGroupId !== (action as IDeletePLUGroupAction).payload
        ),
        pluGroupDeleted: true,
        pluGroup: state.pluGroup
          ? {
              ...state.pluGroup,
              subgroups: Array.isArray(state.pluGroup.subgroups)
                ? state.pluGroup.subgroups.filter(
                    (pluGroup: IPLUGroup) =>
                      pluGroup.pluGroupId !== (action as IDeletePLUGroupAction).payload
                  )
                : [],
            }
          : null,
      };
    case DELETE_INITIATED:
      return {
        ...state,
        ...resetActionsSync,
        deleteInitiated: true,
      };
    case PLU_GROUP_SYNC:
      return {
        ...state,
        ...resetActionsSync,
        pluGroupSyncing: true,
      };
    case CLEAN_PLUGROUP:
      return {
        ...state,
        pluGroup: null,
      };
    case SYNC_FAILED:
      return { ...state, error: (action as IFailedSyncAction).payload };
    default:
      return state;
  }
};
